import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
interface SplashScreenProps {
  onComplete: () => void;
}
const SplashScreen: React.FC<SplashScreenProps> = ({
  onComplete
}) => {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          setTimeout(onComplete, 500);
          return 100;
        }
        return prev + 2;
      });
    }, 30);
    return () => clearInterval(interval);
  }, [onComplete]);
  return <motion.div initial={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.5
  }} className="fixed inset-0 z-50 bg-gradient-to-br from-gray-900 via-purple-900 to-gray-900 flex items-center justify-center overflow-hidden" data-id="element-148">
      {/* Animated background particles */}
      <div className="absolute inset-0" data-id="element-149">
        {[...Array(50)].map((_, i) => <motion.div key={i} className="absolute w-1 h-1 bg-purple-400 rounded-full" initial={{
        x: Math.random() * window.innerWidth,
        y: Math.random() * window.innerHeight,
        opacity: 0
      }} animate={{
        y: [null, Math.random() * window.innerHeight],
        opacity: [0, 1, 0]
      }} transition={{
        duration: Math.random() * 3 + 2,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-150" />)}
      </div>
      {/* Main content */}
      <div className="relative z-10 text-center" data-id="element-151">
        {/* Logo with glitch/AI construction effect */}
        <div className="relative" data-id="element-152">
          {/* Main logo */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.3
        }} data-id="element-153">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/weJPa2B6KxMjVxBcMFKGGT/LOGO_GRUPO_REFLEX.png" alt="Grupo Reflex" className="h-32 md:h-48 mx-auto mb-8 brightness-0 invert relative z-10" data-id="element-154" />
          </motion.div>
          {/* Glitch layers */}
          <motion.div className="absolute inset-0" animate={{
          x: [0, -2, 2, 0],
          opacity: [0, 0.5, 0]
        }} transition={{
          duration: 0.3,
          repeat: Infinity,
          repeatDelay: 2
        }} data-id="element-155">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/weJPa2B6KxMjVxBcMFKGGT/LOGO_GRUPO_REFLEX.png" alt="" className="h-32 md:h-48 mx-auto mb-8 brightness-0 invert opacity-70" style={{
            filter: 'hue-rotate(90deg)'
          }} data-id="element-156" />
          </motion.div>
          <motion.div className="absolute inset-0" animate={{
          x: [0, 2, -2, 0],
          opacity: [0, 0.5, 0]
        }} transition={{
          duration: 0.3,
          repeat: Infinity,
          repeatDelay: 2,
          delay: 0.1
        }} data-id="element-157">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/weJPa2B6KxMjVxBcMFKGGT/LOGO_GRUPO_REFLEX.png" alt="" className="h-32 md:h-48 mx-auto mb-8 brightness-0 invert opacity-70" style={{
            filter: 'hue-rotate(270deg)'
          }} data-id="element-158" />
          </motion.div>
          {/* Scanning line effect */}
          <motion.div className="absolute left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-purple-500 to-transparent" initial={{
          top: 0,
          opacity: 0
        }} animate={{
          top: ['0%', '100%'],
          opacity: [0, 1, 0]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'linear'
        }} data-id="element-159" />
          {/* Pixel construction effect */}
          {[...Array(8)].map((_, i) => <motion.div key={i} className="absolute inset-0" initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: [0, 0.3, 0],
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: i * 0.1,
          repeat: Infinity,
          repeatDelay: 3
        }} data-id="element-160">
              <div className="h-32 md:h-48 mx-auto mb-8 border-2 border-purple-500" style={{
            clipPath: `inset(${i * 12.5}% 0 ${100 - (i + 1) * 12.5}% 0)`
          }} data-id="element-161" />
            </motion.div>)}
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5,
        duration: 0.8
      }} className="space-y-4" data-id="element-162">
          <h2 className="text-2xl md:text-3xl font-bold text-white" data-id="element-163">
            Transformando el futuro
          </h2>
          <motion.p className="text-purple-300" animate={{
          opacity: [0.5, 1, 0.5]
        }} transition={{
          duration: 2,
          repeat: Infinity
        }} data-id="element-164">
            Cargando experiencia...
          </motion.p>
        </motion.div>
        {/* Progress bar */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1
      }} className="mt-8 w-64 mx-auto" data-id="element-165">
          <div className="h-1 bg-gray-700 rounded-full overflow-hidden" data-id="element-166">
            <motion.div className="h-full bg-gradient-to-r from-purple-500 to-pink-500" style={{
            width: `${progress}%`
          }} transition={{
            duration: 0.3
          }} data-id="element-167" />
          </div>
          <p className="text-purple-300 text-sm mt-2" data-id="element-168">{progress}%</p>
        </motion.div>
        {/* Glowing orb effect */}
        <motion.div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-purple-500 rounded-full opacity-20 blur-3xl" animate={{
        scale: [1, 1.2, 1],
        opacity: [0.2, 0.3, 0.2]
      }} transition={{
        duration: 3,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-169" />
      </div>
    </motion.div>;
};
export default SplashScreen;